<template>
  <div class="p-15">
    <el-form ref="ruleForm" :model="submitForm" :rules="rules" label-width="auto" :disabled="disabled">
      <el-card header="基本信息">
        <el-form-item label="活动时间" prop="date_range">
          <el-date-picker
              v-model="submitForm.date_range"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="请选择开始时间"
              end-placeholder="请选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动名称" prop="title">
          <el-input v-model.trim="submitForm.title" placeholder="请输入活动名称，不超过30字" :maxlength="30" show-word-limit class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="活动标签" prop="tag">
          <el-input v-model.trim="submitForm.tag" placeholder="请输入活动名称，不超过10字" :maxlength="10" show-word-limit class="el-input-cover"></el-input>
        </el-form-item>
      </el-card>
      <el-card header="活动规则" class="m-t-20">
        <el-form-item label="兑奖期限" prop="limitDay">
          <el-input v-model.number="submitForm.limitDay" :min="0" placeholder="请输入活动发放礼品领奖截止天数（0表示不限制）" type="number" class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="连签奖励" required>
          <span v-for="(rule_item,rule_index) in submitForm.rules" :key="rule_item.uuid">
            <div v-if="rule_item.type === CONTINUITY_SIGN" class="m-b-18 flex">
              <div>
                <el-input v-model="rule_item.condition" class="w-100" disabled>
                  <template slot="append">天</template>
                </el-input>
              </div>
              <prize-option @input="handleChangeOption(rule_index,rule_item)" v-model="rule_item.prize_type" class="m-l-5" :disabled="continuity_disabled"></prize-option>
              <el-form-item v-if="rule_item.prize_type === CREDIT" :prop="'rules.'+rule_index+'.quantity'" :rules="{required:true,message:'请输入积分',trigger:'blur'}">
                <el-input v-model.number="rule_item.quantity" :placeholder="placeholder(rule_item)" type="number" :min="0" style="width: 250px" class="m-l-5 m-r-5" :disabled="continuity_disabled"></el-input>
              </el-form-item>
              <el-form-item v-else :prop="'rules.'+rule_index+'.optionId'" :rules="{required:true,message:'请选择奖项',trigger:['blur','change']}">
                <el-select
                    :disabled="continuity_disabled"
                    style="width: 250px" class="m-l-5 m-r-5"
                    v-model="rule_item.optionId"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="placeholder(rule_item)"
                    :remote-method="(word)=> remoteMethod(word,rule_index,rule_item)"
                    :loading="loading">
                  <el-option
                      v-for="prizeOption in rule_item.prize_options"
                      :key="prizeOption.id"
                      :label="prizeOption.title"
                      :value="prizeOption.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :prop="'rules.'+rule_index+'.stock'" :rules="{required:true,message:'请输入数量',trigger:'blur'}">
                <el-input v-model.number="rule_item.stock" placeholder="活动数量" type="number" :min="0" style="width: 120px" class="m-r-5" :disabled="continuity_disabled"></el-input>
              </el-form-item>
              <el-form-item :prop="'rules.'+rule_index+'.photoUrl'" :rules="{required:true,message:'弹窗',trigger:['blur','change']}">
                <uploader @success="(data,list)=>ruleUploadSuccess(list,rule_index,rule_item)" @remove="(list)=>ruleRemove(list,rule_index,rule_item)" :file-list="rulePhoto(rule_item)" list-type="picture-card" show-file-list small></uploader>
              </el-form-item>
            </div>
          </span>
        </el-form-item>
        <el-form-item label="首签奖励">
          <span v-for="(rule_item,rule_index) in submitForm.rules" :key="rule_item.uuid">
            <div v-if="rule_item.type === FIRST_SIGN" class="flex col-center m-b-18">
              <prize-option @input="handleChangeOption(rule_index,rule_item)" v-model="rule_item.prize_type" class="m-l-5" style="width: 257px"></prize-option>
              <el-form-item v-if="rule_item.prize_type === CREDIT" :prop="'rules.'+rule_index+'.quantity'" :rules="{required:true,message:'请输入积分',trigger:'blur'}">
                <el-input v-model.number="rule_item.quantity" :placeholder="placeholder(rule_item)" type="number" :min="0" style="width: 250px" class="m-l-5 m-r-5"></el-input>
              </el-form-item>
              <el-form-item v-else :prop="'rules.'+rule_index+'.optionId'" :rules="{required:true,message:'请选择奖项',trigger:['blur','change']}">
                <el-select
                    style="width: 250px" class="m-l-5 m-r-5"
                    v-model="rule_item.optionId"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="placeholder(rule_item)"
                    :remote-method="(word)=> remoteMethod(word,rule_index,rule_item)"
                    :loading="loading">
                  <el-option
                      v-for="prizeOption in rule_item.prize_options"
                      :key="prizeOption.id"
                      :label="prizeOption.title"
                      :value="prizeOption.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :prop="'rules.'+rule_index+'.stock'" :rules="{required:true,message:'请输入数量',trigger:'blur'}">
                <el-input v-model.number="rule_item.stock" placeholder="活动数量" type="number" :min="0" style="width: 120px" class="m-r-5"></el-input>
              </el-form-item>
              <i @click="removePrize(rule_index)" class="el-icon-error fz-22" :class="disabled ? 'disable-color':'danger-color'"></i>
            </div>
          </span>
          <el-link v-if="!disabled" @click="addPrize(FIRST_SIGN)" type="primary">添加奖励层级</el-link>
        </el-form-item>
        <el-form-item label="累签奖励">
           <span v-for="(rule_item,rule_index) in submitForm.rules" :key="rule_item.uuid">
            <div v-if="rule_item.type === ACCUMULATE_SIGN" class="m-b-18 flex col-center">
             <el-form-item :prop="'rules.'+rule_index+'.condition'" :rules="{required:true,message:'请输入累签天数',trigger:'blur'}">
                <el-input v-model="rule_item.condition" placeholder="累签天数" :min="1" type="number" style="width: 120px"></el-input>
             </el-form-item>
              <prize-option @input="handleChangeOption(rule_index,rule_item)" v-model="rule_item.prize_type" class="m-l-5" style="width: 135px"></prize-option>
              <el-form-item v-if="rule_item.prize_type === CREDIT" :prop="'rules.'+rule_index+'.quantity'" :rules="{required:true,message:'请输入积分',trigger:'blur'}">
                <el-input v-model.number="rule_item.quantity" :placeholder="placeholder(rule_item)" type="number" :min="0" style="width: 250px" class="m-l-5 m-r-5"></el-input>
              </el-form-item>
              <el-form-item v-else :prop="'rules.'+rule_index+'.optionId'" :rules="{required:true,message:'请选择奖项',trigger:['blur','change']}">
                <el-select
                    style="width: 250px" class="m-l-5 m-r-5"
                    v-model="rule_item.optionId"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="placeholder(rule_item)"
                    :remote-method="(word)=> remoteMethod(word,rule_index,rule_item)"
                    :loading="loading">
                  <el-option
                      v-for="prizeOption in rule_item.prize_options"
                      :key="prizeOption.id"
                      :label="prizeOption.title"
                      :value="prizeOption.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :prop="'rules.'+rule_index+'.stock'" :rules="{required:true,message:'请输入数量',trigger:'blur'}">
                <el-input v-model.number="rule_item.stock" placeholder="活动数量" type="number" :min="0" style="width: 120px" class="m-r-5"></el-input>
              </el-form-item>
              <i @click="removePrize(rule_index)" class="el-icon-error fz-22" :class="disabled ? 'disable-color':'danger-color'"></i>
            </div>
          </span>
          <el-link v-if="!disabled" @click="addPrize(ACCUMULATE_SIGN)" type="primary">添加奖励层级</el-link>
        </el-form-item>
      </el-card>
      <!--      <el-card class="m-t-20" header="页面配置">-->
      <!--        <el-form-item label="皮肤模式" required>-->
      <!--          <el-select v-model="submitForm.pageSetting.skinMode" placeholder="请选择皮肤">-->
      <!--            <el-option-->
      <!--                v-for="item in SKIN_MODE"-->
      <!--                :key="item.value"-->
      <!--                :label="item.label"-->
      <!--                :value="item.value">-->
      <!--            </el-option>-->
      <!--          </el-select>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="颜色配置" required>-->
      <!--          <div class="flex">-->
      <!--            <el-form-item prop="pageSetting.color.subject">-->
      <!--              <el-input v-model.trim="submitForm.pageSetting.color.subject" placeholder="主题色，如#000000" :maxlength="7" style="width: 160px" class="m-r-10"></el-input>-->
      <!--            </el-form-item>-->
      <!--            <el-form-item prop="pageSetting.color.sub">-->
      <!--              <el-input v-model.trim="submitForm.pageSetting.color.sub" placeholder="辅助色，如#000000" :maxlength="7" style="width: 160px" class="m-r-10"></el-input>-->
      <!--            </el-form-item>-->
      <!--            <el-form-item prop="pageSetting.color.bg">-->
      <!--              <el-input v-model.trim="submitForm.pageSetting.color.bg" placeholder="背景色，如#000000" :maxlength="7" style="width: 160px" class="m-r-10"></el-input>-->
      <!--            </el-form-item>-->
      <!--            <el-form-item prop="pageSetting.color.title">-->
      <!--              <el-input v-model.trim="submitForm.pageSetting.color.title" placeholder="标题色，如#000000" :maxlength="7" style="width: 160px"></el-input>-->
      <!--            </el-form-item>-->
      <!--          </div>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="页面配置" required>-->
      <!--          <div class="flex">-->
      <!--            <el-form-item class="m-r-10" prop="pageSetting.page.activityBg">-->
      <!--              <uploader @success="(data,list)=>pageUploadSuccess(list,'activityBg')" @remove="(list)=>pageRemove(list,'activityBg')" :file-list="activityBg" list-type="picture-card" show-file-list></uploader>-->
      <!--            </el-form-item>-->
      <!--            <el-form-item prop="pageSetting.page.activityText">-->
      <!--              <uploader @success="(data,list)=>pageUploadSuccess(list,'activityText')" @remove="(list)=>pageRemove(list,'activityText')" :file-list="activityText" list-type="picture-card" show-file-list></uploader>-->
      <!--            </el-form-item>-->
      <!--          </div>-->
      <!--        </el-form-item>-->
      <!--      </el-card>-->
      <!--      <el-card class="m-t-20" header="分享设置">-->
      <!--        <el-form-item label="分享海报" required>-->
      <!--          <div class="flex">-->
      <!--            <el-form-item class="m-r-10" prop="shareSetting.friendPoster">-->
      <!--              <uploader @success="(data,list)=>shareUploadSuccess(list,'friendPoster')" @remove="(list)=>shareRemove(list,'friendPoster')" :file-list="friendPoster" list-type="picture-card" show-file-list></uploader>-->
      <!--            </el-form-item>-->
      <!--            <el-form-item prop="shareSetting.friendCirclePoster">-->
      <!--              <uploader @success="(data,list)=>shareUploadSuccess(list,'friendCirclePoster')" @remove="(list)=>shareRemove(list,'friendCirclePoster')" :file-list="friendCirclePoster" list-type="picture-card" show-file-list></uploader>-->
      <!--            </el-form-item>-->
      <!--          </div>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="分享文案" prop="shareSetting.shareText">-->
      <!--          <el-input v-model.trim="submitForm.shareSetting.shareText" placeholder="请输入分享文案，不超过20字" :maxlength="20" class="el-input-cover" show-word-limit></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-card>-->
      <el-card class="m-t-20">
        <tinymce ref="tinymce" v-model="submitForm.desc"></tinymce>
        <el-form-item v-if="!disabled" label-width="0" class="m-t-20">
          <el-button @click="submit" :loading="loading" type="primary">立即提交</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import PrizeOption from "@/views/Interaction/components/prize-option";
import Tinymce from "@/components/Tinymce";
import {ACCUMULATE_SIGN, CHECK_COLOR, COLOR_REG, CONTINUITY_SIGN, CREDIT, FIRST_SIGN, PRIZE_TYPE, SKIN_MODE} from "@/enums/interaction";
import {cloneDeep, random} from "lodash";
import {createSignActivity, getPrizeOption, signDocument, updateSignActivity} from "@/api/interaction";
import {ENDED, NORMAL} from "@/enums/gift";

export default {
  name: "sign-detail",
  components: {
    Tinymce, PrizeOption
  },
  computed: {
    rulePhoto() {
      return (rule_item) => {
        return rule_item.photoUrl ? [{url: rule_item.photoUrl}] : []
      }
    },
    activityBg() {
      return this.submitForm.pageSetting.page.activityBg ? [{url: this.submitForm.pageSetting.page.activityBg}] : []
    },
    activityText() {
      return this.submitForm.pageSetting.page.activityText ? [{url: this.submitForm.pageSetting.page.activityText}] : []
    },
    friendPoster() {
      return this.submitForm.shareSetting.friendPoster ? [{url: this.submitForm.shareSetting.friendPoster}] : []
    },
    friendCirclePoster() {
      return this.submitForm.shareSetting.friendCirclePoster ? [{url: this.submitForm.shareSetting.friendCirclePoster}] : []
    },
    placeholder() {
      return (item) => {
        return item.prize_type ? PRIZE_TYPE.find(option => option.value === item.prize_type).desc : ''
      }
    },
    disabled() {
      return this.submitForm?.status === ENDED
    },
    continuity_disabled() {
      return this.submitForm?.status === NORMAL
    }
  },
  watch: {
    'submitForm.date_range': function (val) {
      const [start_time, end_time] = val
      this.submitForm.startTime = start_time
      this.submitForm.endTime = end_time
    }
  },
  data() {
    return {
      loading: false,

      submitForm: {
        startTime: undefined,
        endTime: undefined,
        title: undefined,
        tag: undefined,

        limitDay: undefined,
        rules: [],
        pageSetting: {
          page: {
            activityBg: undefined,
            activityText: undefined
          },
          color: {
            subject: undefined,
            sub: undefined,
            bg: undefined,
            title: undefined,

          },
          skinMode: "default"
        },
        shareSetting: {
          shareText: undefined,
          friendPoster: undefined,
          friendCirclePoster: undefined
        },
        desc: undefined,

        date_range: []
      },
      rules: {
        date_range: [{required: true, message: '请选择活动时间', trigger: 'change', type: 'array'}],
        title: [{required: true, message: '请输入活动名称', trigger: 'blur'}],
        tag: [{required: true, message: '请输入活动标签', trigger: 'blur'}],
        limitDay: [{required: true, message: '请输入活动发放礼品领奖截止天数', trigger: 'blur'}],
        'pageSetting.page.activityBg': [{required: true, message: '请上传活动背景', trigger: ['blur', 'change']}],
        'pageSetting.page.activityText': [{required: true, message: '请上传活动文案', trigger: ['blur', 'change']}],
        'pageSetting.color.subject': [{required: true, message: '请输入主题色', trigger: ['blur', 'change']}, {validator: CHECK_COLOR}],
        'pageSetting.color.sub': [{required: true, message: '请输入辅助色', trigger: ['blur', 'change']}, {validator: CHECK_COLOR}],
        'pageSetting.color.bg': [{required: true, message: '请输入背景色', trigger: ['blur', 'change']}, {validator: CHECK_COLOR}],
        'pageSetting.color.title': [{required: true, message: '请输入标题色', trigger: ['blur', 'change']}, {validator: CHECK_COLOR}],
        'shareSetting.shareText': [{required: true, message: '请输入分享文案', trigger: 'blur'}],
        'shareSetting.friendPoster': [{required: true, message: '请上传会话海报', trigger: ['blur', 'change']}],
        'shareSetting.friendCirclePoster': [{required: true, message: '请上传本地海报', trigger: ['blur', 'change']}],
      },

      SKIN_MODE,
      CREDIT,
      PRIZE_TYPE,
      CONTINUITY_SIGN,
      FIRST_SIGN,
      ACCUMULATE_SIGN,
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          let form = cloneDeep(this.submitForm)
          delete form.date_range
          delete form.status
          form.rules.forEach(item => {
            item.awardSettings = [{
              type: item.prize_type,
              stock: item.stock,
              quantity: item.quantity,
              optionId: item.optionId,
              userDispatchSettingId: item.userDispatchSettingId
            }]
            delete item.prize_type
            delete item.stock
            delete item.quantity
            delete item.optionId
            delete item.prize_options
            delete item.uuid
            delete item.userDispatchSettingId
          })

          try {
            form.id ? await updateSignActivity(form) : await createSignActivity(form)

            this.$refs.ruleForm.resetFields()

            this.submitForm.rules = this.initRules()
            this.$refs.tinymce.setContent('')

            this.$message.success('操作成功')

            this.$router.back()
          } finally {
            this.loading = false
          }
        }
      })
    },
    pageUploadSuccess(list, field) {
      this.submitForm.pageSetting.page[field] = list[0].url
    },
    pageRemove(list, field) {
      this.submitForm.pageSetting.page[field] = undefined
    },
    shareUploadSuccess(list, field) {
      this.submitForm.shareSetting[field] = list[0].url
    },
    shareRemove(list, field) {
      this.submitForm.shareSetting[field] = undefined
    },
    ruleUploadSuccess(list, rule_index, rule_item) {
      rule_item.photoUrl = list[0].url
      this.$set(this.submitForm.rules, rule_index, rule_item)
    },
    ruleRemove(list, rule_index, rule_item) {
      rule_item.photoUrl = undefined
      this.$set(this.submitForm.rules, rule_index, rule_item)
    },
    async remoteMethod(word, rule_index, rule_item) {
      this.loading = true
      try {
        const {collection} = await getPrizeOption({type: rule_item.prize_type, title: `%${word}%`})
        rule_item.prize_options = collection
        rule_item.optionId = undefined
        this.$set(this.submitForm.rules, rule_index, rule_item)
      } finally {
        this.loading = false
      }
    },
    async handleChangeOption(rule_index, rule_item) {
      this.loading = true
      try {
        const {collection} = await getPrizeOption({type: rule_item.prize_type})
        rule_item.prize_options = collection
        rule_item.optionId = collection[0]?.id || undefined;
        this.$set(this.submitForm.rules, rule_index, rule_item)
      } finally {
        this.loading = false
      }
    },
    addPrize(prize_type) {
      this.submitForm.rules.push({...RULE_TEMPLATE, type: prize_type, uuid: random(0, 99999)})
    },
    removePrize(rule_index) {
      if (this.disabled) return
      this.submitForm.rules.splice(rule_index, 1)
    },
    initRules() {
      let rules = []
      for (let i = 1; i <= 7; i++) {
        rules.push({...RULE_TEMPLATE, condition: i, uuid: random(0, 99999)})
      }
      return cloneDeep(rules)
    }
  },
  async mounted() {
    const {id} = this.$route.query

    if (id) {
      let loading = this.$loading({text: '加载数据中。。。'})
      try {
        const {document} = await signDocument(id)

        document.date_range = [document.startTime, document.endTime]
        for (const item of document.rules) {
          const awardSettings = item.awardSettings

          item.optionId = awardSettings[0].optionId
          item.quantity = awardSettings[0].quantity
          item.stock = awardSettings[0].stock
          item.prize_type = awardSettings[0].type
          item.userDispatchSettingId = awardSettings[0]?.userDispatchSettingId
          item.uuid = item.id

          if (item.optionId) {
            const {collection} = await getPrizeOption({id: item.optionId})
            item.prize_options = collection
          }

          delete item.awardSettings
        }

        this.submitForm = {...document}
      } finally {
        loading.close()
      }
    } else {
      this.submitForm.rules = this.initRules()
    }
  }
}

const RULE_TEMPLATE = {
  type: CONTINUITY_SIGN,
  condition: 1,
  photoUrl: undefined,
  prize_type: "credit",
  stock: undefined,
  quantity: undefined,
  optionId: 1,
  userDispatchSettingId: undefined
}
</script>

<style lang="less" scoped>

</style>